import moment from "moment";

export default {
  type: "equipment-transfers",
  code: null,
  name: "",
  transfer_date: moment().format("YYYY-MM-DD"),
  transfer_type: "PERMANENT",
  return_date: null,
  status: "DRAFT",
  excerpt: "",
  relationshipNames: [
    "organization",
    "serviceCenter",
    "sourceEstablishment",
    "destinationEstablishment",
    "items",
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  sourceEstablishment: {
    type: "establishments",
    id: null,
  },
  destinationEstablishment: {
    type: "establishments",
    id: null,
  },
  items: [],
};
